// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header_title":"Header_header_title__AlAIj","title":"Header_title__x3ga3"};